import { ShopifyCartItem } from '@/lib/shopify';
import { CartItemProperty } from '@/core/constants';
import {
  convertCartLineItemPropertiesToAttributes,
  getCartLineItemProperty,
} from '@/utils/shopify';

import { SubscriptionPlanSettings } from './types';

export function buildSubscriptionPlanKey(
  subscriptionPlanProducts: ShopifyCartItem[],
): SubscriptionPlanSettings[] {
  return subscriptionPlanProducts
    .map((subscriptionPlan) => {
      const attributes = convertCartLineItemPropertiesToAttributes(
        subscriptionPlan.properties,
      );

      const subscriptionPlanSettings = getCartLineItemProperty(
        CartItemProperty.SubscriptionPlanSettings,
        attributes,
        { parseJson: true },
      );

      if (!subscriptionPlanSettings) {
        return null;
      }

      return subscriptionPlanSettings as unknown as SubscriptionPlanSettings;
    })
    .filter(isValidSubscriptionPlanSettings);
}

function isValidSubscriptionPlanSettings(
  settings: SubscriptionPlanSettings | null,
): settings is SubscriptionPlanSettings {
  return settings !== null;
}
